<template>
    <ini-badge v-bind="$props" :class="['ini-badge', 'ini-badge__' + name, 'ini-badge--default ini-badge__' + name + '--' + transformToModifierClass(value) ]">
        <slot></slot>
    </ini-badge>
</template>

<script>
    import IniBadge from '@/components/Badge'
    import StyleMixin from '@/mixins/StyleMixin'

    export default {
        extends: IniBadge,
        mixins: [StyleMixin],
        props: {
            name: String,
            value: String,
        },
        components: {
            IniBadge
        },
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/_badge.scss";</style>